import React, { useMemo } from 'react';
import { Icon } from '../icon';
import { StarFillIcon } from '../icons/stars/star-fill-icon';
import { StarHalfIcon } from '../icons/stars/star-half-icon';
import { StarOutlineIcon } from '../icons/stars/start-outline-icon';
import { RatingLabel } from './rating-label';
import style from './styles.module.css';
const IconsMap = {
  full: StarFillIcon,
  half: StarHalfIcon,
  empty: StarOutlineIcon
};
export const RatingLayout = ({
  value,
  labelVariant = 'default',
  children,
  color = 'brand-primary'
}) => {
  const validRating = useMemo(() => {
    if (value > 0) {
      return value < 5 ? +value.toFixed(1) : 5;
    }
    return 0;
  }, [value]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: style.starsWrap
  }, [1, 2, 3, 4, 5].map(starValue => {
    const diff = validRating - starValue + 1;
    let starType;
    if (diff >= 1) starType = 'full';else if (diff >= 0.5) starType = 'half';else starType = 'empty';
    const StartIcon = IconsMap[starType];
    return /*#__PURE__*/React.createElement("div", {
      key: starValue
    }, /*#__PURE__*/React.createElement(Icon, {
      className: style.starIcon,
      color: color,
      "data-testid": `rating-star-${starValue}`
    }, /*#__PURE__*/React.createElement(StartIcon, null)));
  })), labelVariant && /*#__PURE__*/React.createElement(RatingLabel, {
    labelVariant: labelVariant
  }, children));
};